// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import appealTopicEntity from './entities/appeal-topic.json';
import appealTopicMenu from '../pages/appeal-topic/menu.json';
import appealTopicFullForm from '../pages/appeal-topic/forms/full.json';
import appealTopicContextForm from '../pages/appeal-topic/forms/context.json';
import appealTopicMiniForm from '../pages/appeal-topic/forms/mini.json';
import appealTopicLookupForm from '../pages/appeal-topic/forms/lookup.json';
import appealTopicTableView from '../pages/appeal-topic/views/table.json';
import appealTopicDashboardView from '../pages/appeal-topic/views/dashboard.json';

/** Тип запису «Тема звернення» зі сторінками пакета: меню, форми та подання з pages/appeal-topic/. */
export const appealTopicDefinition: IRecordTypeDefinition = {
  ...appealTopicEntity,
  views: assembleViewSet({
      table: appealTopicTableView,
      dashboard: appealTopicDashboardView,
  }),
  form: appealTopicFullForm,
  forms: { full: appealTopicFullForm, context: appealTopicContextForm, mini: appealTopicMiniForm, lookup: appealTopicLookupForm },
  menu: appealTopicMenu,
} as IRecordTypeDefinition;
